import React from 'react';
import clsx from 'clsx';
import Skeleton from 'core/components/Skeleton';

const thresholdRowClassName = 'flex items-center gap-x-4';

const SKELETON_ROW_KEYS = [
  'row-1',
  'row-2',
  'row-3',
  'row-4',
  'row-5',
  'row-6',
] as const;

function ThresholdColumnHeadersSkeleton() {
  return (
    <div className={clsx(thresholdRowClassName, 'px-3 pb-2')}>
      <div className="w-36 shrink-0">
        <Skeleton variant="rectangular" className="!h-3 !w-12 !rounded" />
      </div>
      <div className="min-w-0 flex-1">
        <Skeleton variant="rectangular" className="!h-3 !w-10 !rounded" />
      </div>
      <div className="min-w-0 flex-1">
        <Skeleton variant="rectangular" className="!h-3 !w-20 !rounded" />
      </div>
    </div>
  );
}

function ThresholdSignalRowSkeleton() {
  return (
    <div
      className={clsx(
        thresholdRowClassName,
        'items-center border-b border-gray-100 px-3 py-4 last:border-b-0',
      )}
    >
      <div className="flex w-36 shrink-0 min-w-0 flex-col gap-1.5">
        <Skeleton variant="rectangular" className="!h-4 !w-28 !rounded" />
        <Skeleton variant="rectangular" className="!h-3 !w-40 !rounded" />
      </div>
      <div className="min-w-0 flex-1">
        <Skeleton variant="rectangular" className="!h-9 !w-full !max-w-[200px] !rounded" />
      </div>
      <div className="min-w-0 flex-1">
        <Skeleton variant="rectangular" className="!h-9 !w-full !max-w-[200px] !rounded" />
      </div>
    </div>
  );
}

export default function ThresholdSettingsDialogSkeleton() {
  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <div className="min-h-0 flex-1 overflow-y-auto p-6 pb-0">
        <div className="flex flex-col">
          <ThresholdColumnHeadersSkeleton />
          <div className="flex flex-col rounded-md border border-gray-200">
            {SKELETON_ROW_KEYS.map((key) => (
              <ThresholdSignalRowSkeleton key={key} />
            ))}
          </div>
        </div>
      </div>
      <div className="flex shrink-0 justify-end gap-3 border-t border-gray-200 px-5 py-4">
        <Skeleton variant="rectangular" className="!h-9 !w-20 !rounded" />
        <Skeleton variant="rectangular" className="!h-9 !w-36 !rounded" />
      </div>
    </div>
  );
}
